module.exports = __webpack_public_path__ + "static/fonts/SVN-Nexa Bold.17e8951c.ttf";